import { HydratedTradingPartner } from '../../common/types/compoundModels.ts';
import {
  TradingPartnerAddress,
  TradingPartnerContact,
} from '../../common/types/models.ts';
import { VerifiedTradingPartnerAPI } from '../../common/api/verifiedTradingPartner.ts';
import { Link } from 'react-router-dom';

type TradingPartnerSelectProps = {
  tradingPartner: HydratedTradingPartner | null;
  tradingPartnerAddress: TradingPartnerAddress | null;
  selectedEmailAddresses: string[];
  setSelectedEmailAddresses: React.Dispatch<React.SetStateAction<string[]>>;
  tradingPartnerContactsWithEmail: TradingPartnerContact[];
  verifiedTradingPartnerEligibility: VerifiedTradingPartnerAPI.Response.ReadOneIsAs2Active | null;
};

const TradingPartnerSelect = ({
  tradingPartner,
  tradingPartnerAddress,
  selectedEmailAddresses,
  setSelectedEmailAddresses,
  tradingPartnerContactsWithEmail,
  verifiedTradingPartnerEligibility,
}: TradingPartnerSelectProps) => {
  //
  // Formatting pushes this function up and I think space would be nice
  //
  const handleCheckbox = (address: string) => {
    setSelectedEmailAddresses(prev =>
      prev.includes(address)
        ? prev.filter(id => id !== address)
        : [...prev, address]
    );
  };

  return (
    <div className="card">
      <div className="card-content">
        <h6>Send To</h6>
        <div className="divider" />

        <div className="row" style={{ padding: '10px', paddingBottom: '0px' }}>
          {tradingPartnerAddress && (
            <>
              <p>{tradingPartnerAddress.addressLineOne}</p>
              {tradingPartnerAddress.addressLineTwo ? (
                <p>{tradingPartnerAddress.addressLineTwo}</p>
              ) : null}
              <p>
                {tradingPartnerAddress.city},{' '}
                {tradingPartnerAddress.state?.code}
              </p>
              <p>{tradingPartnerAddress.postalCode}</p>
            </>
          )}
        </div>
        <div className="row">
          {tradingPartner &&
            !verifiedTradingPartnerEligibility?.isAs2Active &&
            tradingPartnerContactsWithEmail.length > 0 && (
              <div className="input-field col s12">
                <h6>Email Recipients</h6>
                <div className="divider" style={{ marginBottom: '20px' }} />
                {tradingPartnerContactsWithEmail.map(contact => (
                  <p key={contact.id}>
                    <label>
                      <input
                        type="checkbox"
                        className="filled-in"
                        checked={selectedEmailAddresses.includes(
                          contact?.contactDetails?.[0]?.contactDetail || ''
                        )}
                        onChange={() =>
                          handleCheckbox(
                            contact?.contactDetails?.[0]?.contactDetail || ''
                          )
                        }
                      />
                      <span>
                        {contact?.firstName} {contact?.lastName}: (
                        {contact?.contactDetails?.[0]?.contactDetail})
                      </span>
                    </label>
                  </p>
                ))}
              </div>
            )}
        </div>
        <div className="row">
          {tradingPartner &&
            !verifiedTradingPartnerEligibility?.isAs2Active && (
              <>
                <p>
                  This trading partner does not have an active AS2 connection.
                </p>
                {tradingPartnerContactsWithEmail?.length ? (
                  <p>
                    The trading partner will receive an email with a link to
                    download the required epcis directly from MedTrax.com
                  </p>
                ) : (
                  <p>
                    This trading partner also lacks a contact with an email
                    address for us to send a link to. Please add one{' '}
                    <Link to={`/tradingpartner/${tradingPartner.id}`}>
                      here
                    </Link>
                    .
                  </p>
                )}
              </>
            )}
        </div>
        {tradingPartner &&
          !verifiedTradingPartnerEligibility?.hasActiveGlobalLocationNumber && (
            <div className="row">
              <span className="red-text">
                This trading partner does not have a verified global location
                number. Please contact your MedTrax representative.
              </span>
            </div>
          )}
      </div>
    </div>
  );
};

export default TradingPartnerSelect;
